import { ErrorService } from './error/error.service';
import { NgModule } from "@angular/core";
import { IonicStorageModule } from "@ionic/storage";
import { AuthenticationService } from './authentication/authentication.service';
import { AuthenticationHttpService } from "./authentication/authentication-http.service";
import { AuthenticationStorage } from "./authentication/authentication-storage.service";
import { KeystoneAuthStorage, KeystoneHttpModule} from "../../keystone-http";

declare let process: any;

@NgModule({
  imports: [
    IonicStorageModule.forRoot({
      name: 'urmet_storage',
      driverOrder: ['localstorage', 'sqlite']
    }),
    KeystoneHttpModule.forRoot({
      /**
       * TODO: url for testing on real device
       */
      //baseUrl: 'http://192.168.2.197:5000/api',
      //baseUrl: 'http://192.168.2.243:5010/api',
      //baseUrl: 'http://192.168.2.138:5000/api'
      baseUrl: process.env['BACKEND_URL'] || 'http://localhost:5000/api'
      //baseUrl: 'http://sosfamily-stage.molecle.com:5000/api'
    }),
  ],
  providers: [
    //AUTHENTICATION SERVICES
    AuthenticationService,
    AuthenticationStorage,
    AuthenticationHttpService,
    {provide: KeystoneAuthStorage, useExisting: AuthenticationStorage},
    ErrorService
  ]
})
export class CoreModule {};



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts